import {DomainError} from '@s-ui/domain'

export class GetAlertUserAlertsError extends DomainError {
  #cause
  #code
  #message

  static ALERT_NOT_FOUND_ERROR_CODE = 'alert_not_found_get_alert_user_alerts_error'
  static GENERIC_ERROR_CODE = 'generic_get_alert_user_alerts_error'
  static INVALID_PARAMETERS_ERROR_CODE = 'invalid_parameters_get_alert_user_alerts_error'
  static NOT_AUTHENTICATED_ERROR_CODE = 'not_authenticated_get_alert_user_alerts_error'
  static NOT_AUTHORIZED_ERROR_CODE = 'not_authorized_get_alert_user_alerts_error'

  constructor({cause, code, message}) {
    super({cause, code, message})
    this.#cause = cause
    this.#code = code
    this.#message = message
  }

  static isGetAlertUserAlertsError({error}) {
    return error instanceof GetAlertUserAlertsError
  }

  static create({code, message, cause}) {
    return new GetAlertUserAlertsError({code, message, cause})
  }

  static createGenericError({cause}) {
    return GetAlertUserAlertsError.create({
      code: GetAlertUserAlertsError.GENERIC_ERROR_CODE,
      cause,
      message: 'ERRORS.GET_ALERT_USER_ALERTS.GENERIC'
    })
  }

  static createInvalidParametersError() {
    return GetAlertUserAlertsError.create({
      code: GetAlertUserAlertsError.INVALID_PARAMETERS_ERROR_CODE,
      message: 'ERRORS.GET_ALERT_USER_ALERTS.INVALID_PARAMETERS'
    })
  }

  static createNotAuthenticatedError() {
    return GetAlertUserAlertsError.create({
      code: GetAlertUserAlertsError.NOT_AUTHENTICATED_ERROR_CODE,
      message: 'ERRORS.GET_ALERT_USER_ALERTS.NOT_AUTHENTICATED'
    })
  }

  static createNotAuthorizedError() {
    return GetAlertUserAlertsError.create({
      code: GetAlertUserAlertsError.NOT_AUTHORIZED_ERROR_CODE,
      message: 'ERRORS.GET_ALERT_USER_ALERTS.NOT_AUTHORIZED'
    })
  }

  static createAlertNotFoundError() {
    return GetAlertUserAlertsError.create({
      code: GetAlertUserAlertsError.ALERT_NOT_FOUND_ERROR_CODE,
      message: 'ERRORS.GET_ALERT_USER_ALERTS.ALERT_NOT_FOUND'
    })
  }

  get value() {
    return {
      code: this.#code,
      message: this.message,
      cause: this.cause
    }
  }

  isGenericError() {
    return this.#code === GetAlertUserAlertsError.GENERIC_ERROR_CODE
  }

  isInvalidParametersError() {
    return this.#code === GetAlertUserAlertsError.INVALID_PARAMETERS_ERROR_CODE
  }

  isNotAuthenticatedError() {
    return this.#code === GetAlertUserAlertsError.NOT_AUTHENTICATED_ERROR_CODE
  }

  isNotAuthorizedError() {
    return this.#code === GetAlertUserAlertsError.NOT_AUTHORIZED_ERROR_CODE
  }

  isAlertNotFoundError() {
    return this.#code === GetAlertUserAlertsError.ALERT_NOT_FOUND_ERROR_CODE
  }

  toJSON() {
    return {
      code: this.#code,
      message: this.#message,
      cause: this.#cause
    }
  }
}
